import React,{useState, useEffect} from 'react'
import { Link, useNavigate } from "react-router-dom";
import { useFormContext } from '../../Context/FormContext';
import authqueries from '../../queries/authQueries';
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Spin, } from 'antd';

const Step1 = ({setCurrent, current, setCurrentTab, currentTab, handleTabChange, key, navTab, setNavTab}) => {

    const { formData, updateFormData } = useFormContext();

    const navigate = useNavigate()

    const [errName, setErrName] = useState("");

    const [docErrName, setDocErrName] = useState("");

    const [codeErr, setCodErr] = useState("");

    const [err, setErr] = useState(false);

    const [loading, setLoading] = useState(false);

    const validationSchema = yup.object({
        comp_code: yup
          .string("⚠ Invalid Company code")
          .required("⚠ Company code is required"),
        // code: yup
        //   .string("⚠ Ship Type does not exist")
        //   .required("⚠ Ship Type is required"),
        doc_code: yup
          .string("⚠ Invalid Doc code")
          .required("⚠ Doc code is required"),
    });

    

    const { register, control, reset, handleSubmit, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
    });

    // useEffect(() => {
    //     setValue('code', 'O')
    // }, []);

    // const navigate = useNavigate()


    const CompanyExist  = authqueries.useCompanyExistMutation(

        (response) => {
    
    
          if(response?.message === "Success" ) {
            // navigation.navigate('step2')
          }
          else{
            // alert("Company does not exist. Please try again")
            setErrName("⚠ Invalid Company code")
            setErr(false)
            return false
          }
    
        }
        
      );

      const handleData = (e) => {
        console.log(e.target.value)
      }
    
      const DocExist  = authqueries.useDocExistMutation(
    
        (response) => {
    
    
          if(response?.message === "Success" ) {
            updateFormData({ employer_code: formData?.emp_code + formData?.code + formData?.doc_code })
            // navigation.navigate('step2')
            // handleTabChange()
            localStorage.setItem('navTab', "2");
            setCurrentTab("2");
            setNavTab(navTab + 1)
            setCurrent(current + 1)
            setLoading(false)
          }

          else{
            // alert("Docholder does not exist. Please try again")
            setErr(false)
            setDocErrName("⚠ Invalid Doc code")
            setLoading(false)
            return false
          }
    
        }
        
      );


    const onSubmit = async(data) => {

        setLoading(true)

        // console.log(data)

        // if(data.code === "O"){
        //   setCodErr("⚠ Invalid Type!")
        //   setLoading(false)
        //   return false
        // }

        await updateFormData({ emp_code : data.comp_code, doc_code: data.doc_code, code: "V" })
        
        CompanyExist.mutateAsync({data: data?.comp_code});
        DocExist.mutateAsync({data: data?.comp_code + data?.doc_code});

    }

    useEffect(() => {
      const nav = localStorage.getItem('navTab')
      if(nav === "2") {
        setNavTab(2)
      }
    }, []);


  return (

    <div>
        
      <Spin spinning={loading} size='large'>

        <div className="tab-pane fade active show" id="step1" role="tabpanel" aria-labelledby="nav-step1-tab">

            <div className="main-hding">Enter the Workplace Code provided by your employer.</div>

                <form onSubmit={handleSubmit(onSubmit)}>

                    <div className="row">

                        <div className="col" style={{marginTop: '-5px'}}>

                            <label>Employer Code<span style={{color: 'red', fontSize: 17, fontWeight: 'bold'}}>*</span></label>

                            <input 
                                maxLength={3} 
                                defaultValue={formData?.emp_code}
                                name='comp_code' 
                                type="text" 
                                className="form-control"
                                {...register('comp_code')}
                            />

                                {

                                    errors?.comp_code  &&

                                    <div className='err'>
                                        {errors?.comp_code?.message}
                                    </div>

                                }

                                {

                                  errName  &&

                                    <div className='err'>
                                        {errName} 
                                    </div>

                                }



                        </div>

                    <div className="col">

                        <label>&nbsp;</label>

                        <input type="text" disabled value={"V"} className="form-control" name='code' {...register('code')} />

                        {/* <select defaultValue={formData?.code} className="form-control" {...register('code')}>
                            
                            <option value={""}>Select</option>
                            <option value={"O"}>O</option>
                            <option value={"V"}>V</option>

                        </select> */}

                        {

                          errors?.code  &&

                          <div className='err'>
                              {errors?.code?.message}
                          </div>

                        }

                        {

                          codeErr  &&

                          <div className='err'>
                              {codeErr} 
                          </div>

                        }

                    </div>

                    <div className="col">

                        <label>&nbsp;</label>

                        <input 
                            maxLength={8} 
                            type="text" 
                            defaultValue={formData?.doc_code}
                            name='doc_code' 
                            className="form-control" 
                            {...register('doc_code')}
                        />

                        {

                        errors?.doc_code  &&

                        <div className='err'>
                            {errors?.doc_code?.message} 
                        </div>

                        }

                        {

                        docErrName  &&

                        <div className='err'>
                            {docErrName} 
                        </div>

                        }

                    </div>

                   

                    </div>

                    <div className="row">

                        {/* <button className="btn btn-primary btn-informant gotoStp2"  data-bs-toggle="tab" data-bs-target="#step2" role="tab" aria-controls="step2" aria-selected="false" type="button">Next <i className="icon-arrow-right1"></i></button> */}

                        <div className="d-grid gap-2 mt-4 nav">
                            
                          <button className="btn btn-primary btn-informant" type="submit">Next <i className="icon-arrow-right1"></i></button>

                        </div>

                    </div>

                </form>

                <div>


                </div>

            <div>

                <div className="info">

                    <div className="text-center mt-5">Report your Workplace Issue. Your identity will remain anonymous</div>

                        <div className="donthave">

                            <div className="donthave-label">Don't have Workplace code?</div>

                            <button className="btn btn-default btn-clickhere" onClick={() => navigate('/complaint_public')}>Click Here</button>
                        
                        </div>
                
                </div>

            </div>

            <div className='row mt-3'>

              <div className='col-md-6'>

                <div className="d-grid gap-2">

                  <div className='text-right mt-2'>
                    <button className='informButton' onClick={() => navigate('/privacy')}>Privacy Policy</button>
                  </div>

                </div>

              </div>

              <div className='col-md-6'>

                <div className="d-grid gap-2">

                  <div className='text-left mt-2'>
                    <button className='informButton' onClick={() => navigate('/survey')}>Take a Survey</button>
                  </div>

                </div>

              </div>

            </div>

        </div>

      </Spin>

    </div>
  
  )

}

export default Step1